import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdamsDocModel } from 'src/app/models/adams-doc-model';
import { SearchResultsModel } from 'src/app/models/search-results-model';
import { DialogService } from 'primeng/dynamicdialog';
import { ConstantsService } from 'src/app/services/constants.service';

@Component({
  selector: 'app-results-summary-view',
  templateUrl: './results-summary-view.component.html',
  styleUrls: ['./results-summary-view.component.css']
})
export class ResultsSummaryViewComponent implements OnInit {

  @Input() viewItems: SearchResultsModel[] = [];
  @Output() docDetails = new EventEmitter();

  constructor(public dialogService: DialogService, public constants: ConstantsService) {

  }

  ngOnInit(): void {

  }

  show(item: AdamsDocModel) {
    this.docDetails.emit(item);
  }
}
